import * as hooks from '@owl-nest/hooks'

import * as core from '@boutique/services'
import * as entities from '@boutique/entities'
import * as cold from '@owl-nest/cold-data/client'
import { useQueryParams, type UseQueryParams } from '@boutique/hooks'
import * as url from '@boutique/url'

export const HITS_PER_PAGE = 16

export type UseGiftIdeaListing = UseQueryParams<entities.search.giftIdea.Query> & {
  response: hooks.Response<entities.search.giftIdea.Result>
  resetFilters: () => entities.search.giftIdea.Query
  setPerson: (person?: string) => entities.search.giftIdea.Query
  setCriterion: (criteria?: string) => entities.search.giftIdea.Query
  setCategory: (category?: string) => entities.search.giftIdea.Query
  setSort: (sort?: entities.search.Sort) => entities.search.giftIdea.Query
  setPage: (page?: number) => entities.search.giftIdea.Query
  setPriceRange: (range?: { start?: number; end?: number }) => entities.search.giftIdea.Query
}

export function useGiftIdeaListing(): UseGiftIdeaListing {
  const { query, apply, href } = useQueryParams(
    url.giftIdeas().path,
    entities.search.giftIdea.fromParsedUrlQuery,
    (query) => entities.search.giftIdea.toUrlSearchParams(query, cold),
  )

  const { response } = core.search.giftIdea.useGiftIdeaSearch(
    { ...query, hitsPerPage: HITS_PER_PAGE },
    {
      fetchOnMount: 'force',
    },
  )

  return {
    query,
    response,
    apply,
    href,
    resetFilters: () => entities.search.giftIdea.resetFilters(query),
    setPerson: (person) => entities.search.giftIdea.setPerson(query, person),
    setCriterion: (criteria) => entities.search.giftIdea.setCriterion(query, criteria),
    setCategory: (category) => entities.search.giftIdea.setCategory(query, category),
    setSort: (sort) => entities.search.setSort(query, sort),
    setPage: (page) => entities.search.setPage(query, page),
    setPriceRange: (range) => entities.search.setPriceRange(query, range),
  }
}
